import React from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sparkles } from "lucide-react";
import Layout from "../components/Layout";
import ActivityPicker from "../components/ActivityPicker";
import WeeklyActivityReport from "../components/WeeklyActivityReport";
import { STEPS } from "../data/courseData";

export default function DailyPracticePage() {
  const { step } = useParams();
  const stepNum = parseInt(step, 10);
  const meta = STEPS.find((s) => s.step === stepNum);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const fresh = params.get("fresh") === "1";

  return (
    <Layout>
      <button
        onClick={() => navigate(`/journey/${stepNum}`)}
        className="text-sm text-[#9AAEC6] flex items-center gap-1 mb-4 hover:text-white transition-colors"
        data-testid="back-to-step"
      >
        <ArrowLeft size={16} /> Week {stepNum}
      </button>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="space-y-5"
      >
        {fresh && (
          <div
            className="relative overflow-hidden rounded-3xl border p-5"
            style={{
              borderColor: `${meta?.accent || "#22D3EE"}55`,
              background: `linear-gradient(160deg, ${meta?.accent || "#22D3EE"}1A 0%, rgba(10,21,48,0.85) 70%)`,
              boxShadow: `0 16px 40px ${meta?.accent || "#22D3EE"}26`,
            }}
            data-testid="fresh-banner"
          >
            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full" style={{ background: `radial-gradient(circle, ${meta?.accent || "#22D3EE"}55, transparent 70%)` }} />
            <div className="relative flex items-center gap-3">
              <Sparkles size={18} style={{ color: meta?.accent || "#22D3EE" }} />
              <div>
                <div className="bps-eyebrow" style={{ color: meta?.accent }}>You&apos;ve earned this</div>
                <div className="font-display text-lg text-white mt-0.5">Week {stepNum} lesson is done.</div>
                <p className="text-sm text-white/85 mt-1 leading-relaxed">
                  Now reinforce it. <span className="text-white">Choose 7 activities this week</span> and wear the Back Pain Transformer&trade; during each.
                </p>
              </div>
            </div>
          </div>
        )}

        <div>
          <div className="bps-eyebrow" style={{ color: meta?.accent }}>Practice 5 · Daily reinforcement</div>
          <h1 className="font-display text-3xl font-light tracking-tighter mt-1">Your activity log</h1>
          <p className="text-sm text-[#9AAEC6] mt-2 leading-relaxed">
            Pick anything from the categories below. Wear your harness. Mark it done.
            Seven completions finishes Week {stepNum}{stepNum < 4 ? ` and unlocks Week ${stepNum + 1}` : ""}.
          </p>
        </div>

        <ActivityPicker
          stepNum={stepNum}
          accent={meta?.accent}
          onComplete={() => navigate(`/journey/${stepNum}/week-complete`)}
        />

        <div className="pt-2">
          <WeeklyActivityReport compact />
        </div>
      </motion.div>
    </Layout>
  );
}
